import React from 'react'
import { getImages } from '../const';

const InventoryMdItem = ({car, index}) => {
    return (
        <>
            <div className='col-12 animated zoomIn'
                style={{
                    visibility: 'visible',
                    animationDelay: '0.2s',
                    animationName: 'zoomIn'
                }}
                key={index}
            >
                <article className="srp-box srp-full-width">
                    <div className="srp-top">
                        <img src={getImages(car.image)} />
                    </div>
                    <div className="srp-content">
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <div className="sm-title text-white font-bold mb-2">{car.title}</div>
                                <div className="xs-title">{car.content}</div>
                            </div>
                            <div className='text-end'>
                                <div className="sm-title mb-2">{car.price}</div>
                                <div>
                                    <a href='#' className='btn-white-theme d-inline-block text-nowrap'>Vehicle Details</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </>
    )
}

export default InventoryMdItem